<script setup lang="ts">
import IconDoc from "@/assets/svg/document.svg?component"

defineOptions({
  name: "WTCard"
})

withDefaults(defineProps<{ title?: string; isShowIcon?: boolean }>(), {
  title: "标题",
  isShowIcon: true
})
</script>

<template>
  <div class="w-t-card base-card px-[20px] py-[10px]">
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-x-[5px] font-bold text-[16px]">
        <template v-if="isShowIcon">
          <slot name="icon"><IconDoc class="w-[18px]" /></slot>
        </template>
        <div>{{ title }}</div>
      </div>

      <slot name="action" />
    </div>

    <div class="py-[10px]">
      <slot name="default" />
    </div>
  </div>
</template>
